import { ActionTypes } from "../contants/action-type";

const initialState = {
    branches: [],
    branch: {}
}

export const BranchReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_BRANCH:
            return {...state, branches: payload};
        case ActionTypes.SELECTED_BRANCH:
            return {...state, branch: payload};
        case ActionTypes.CONFIRM_CREATE_BRANCH:
            return {...state, branch: payload};
        case ActionTypes.CONFIRM_DELETE_BRANCH:
            return {...state, branches: payload};
        default:
            return state;
    }
}